import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Facebook } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#C4A77D] text-white" data-testid="footer">
      <div className="container-main py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium mb-4 text-[#F4EDE6]">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li><Link to="/vad-ar-vardagslyx" className="text-white/70 hover:text-white transition-colors text-sm">{t('footer.about')}</Link></li>
              <li><Link to="/upplevelser" className="text-white/70 hover:text-white transition-colors text-sm">{t('footer.experiences')}</Link></li>
              <li><Link to="/bli-medlem" className="text-white/70 hover:text-white transition-colors text-sm">{t('footer.membership')}</Link></li>
              <li><Link to="/kontakt" className="text-white/70 hover:text-white transition-colors text-sm">{t('footer.contact')}</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-medium mb-4 text-[#F4EDE6]">{t('home.categoriesTitle')}</h4>
            <ul className="space-y-3">
              <li><Link to="/upplevelser?category=restaurang" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.restaurang')}</Link></li>
              <li><Link to="/upplevelser?category=wellness" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.wellness')}</Link></li>
              <li><Link to="/upplevelser?category=traning" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.traning')}</Link></li>
              <li><Link to="/upplevelser?category=hotell" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.hotell')}</Link></li>
              <li><Link to="/upplevelser?category=kultur" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.kultur')}</Link></li>
              <li><Link to="/upplevelser?category=hem" className="text-white/70 hover:text-white transition-colors text-sm">{t('categories.hem')}</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-medium mb-4 text-[#F4EDE6]">{t('footer.contactTitle')}</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/70 text-sm">
                <Mail className="w-4 h-4" />
                <span>info@vardagslyx.nu</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/vardagslyxab/" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors"><Instagram className="w-5 h-5" /></a>
              <a href="https://www.facebook.com/people/Vardagslyx/61572370867598/" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors"><Facebook className="w-5 h-5" /></a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">© 2024 Vardagslyx. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
}
